// extracted by mini-css-extract-plugin
module.exports = {"small":"Icons_small__B8Q24","normal":"Icons_normal__1pHZK","large":"Icons_large__1THqw"};